import Context from './TranslationContext';
import Provider from './TranslationProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
